import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceTabsService {
  tabList = signal([{ label: 'Editor' }]);
  activeTab = signal(this.tabList()[0]);

  constructor() { } 
}
